import ModelTypeConstants from 'constants/ModelTypeConstants';
import {BenchlingApp, User} from 'constants/UserConstants';
import {Organization, Team} from 'orgs/OrganizationConstants';

export const PARTY_TYPES = [
  ModelTypeConstants.BENCHLING_APP,
  ModelTypeConstants.ENTITY,
  ModelTypeConstants.TEAM,
] as const;

export const ALL_LEAF_PARTY_TYPES = [
  ModelTypeConstants.BENCHLING_APP,
  ModelTypeConstants.ORGANIZATION,
  ModelTypeConstants.ROUTINE,
  ModelTypeConstants.SERVICE_ACCOUNT,
  ModelTypeConstants.TEAM,
  ModelTypeConstants.USER,
] as const;

export type PartyType = (typeof ALL_LEAF_PARTY_TYPES)[number];

export type Party = User | Organization | Team | BenchlingApp;

export interface PartySummary {
  id: string;
  name: string;
  handle: string;
  avatar_url?: string;
  type: PartyType;
}

export type PartyTypename =
  | 'OrganizationNode'
  | 'RoutineNode'
  | 'TeamNode'
  | 'BenchlingAppNode'
  | 'ServiceAccountActorNode'
  | 'UserNode';

export const PARTY_TYPE_TO_GRAPHQL_TYPENAME: Record<PartyType, PartyTypename> = {
  [ModelTypeConstants.BENCHLING_APP]: 'BenchlingAppNode',
  [ModelTypeConstants.ORGANIZATION]: 'OrganizationNode',
  [ModelTypeConstants.ROUTINE]: 'RoutineNode',
  [ModelTypeConstants.SERVICE_ACCOUNT]: 'ServiceAccountActorNode',
  [ModelTypeConstants.TEAM]: 'TeamNode',
  [ModelTypeConstants.USER]: 'UserNode',
};

export const PARTY_GRAPHQL_TYPENAME_TO_PARTY_TYPE: Record<PartyTypename, PartyType> = {
  BenchlingAppNode: ModelTypeConstants.BENCHLING_APP,
  OrganizationNode: ModelTypeConstants.ORGANIZATION,
  RoutineNode: ModelTypeConstants.ROUTINE,
  ServiceAccountActorNode: ModelTypeConstants.SERVICE_ACCOUNT,
  TeamNode: ModelTypeConstants.TEAM,
  UserNode: ModelTypeConstants.USER,
};

export type Principal = User | BenchlingApp;

export type Author = Principal;

export type Creator = Principal;
